import { useGetSessionIsExpiredQuery } from '@/services/ApiService';

export const useGetExpiredSession = (options?: { skip?: boolean }) => {
    const { data, isFetching, isError } = useGetSessionIsExpiredQuery(undefined, { skip: options?.skip });

    return {
        isExpired: data?.message !== 'healthy',
        isFetching,
        isError,
    };
};
